import { FunctionComponent } from 'react'
import { NumericFormat } from 'react-number-format'
import { INPUT_FOCUS_RING } from '../../../lib/a11yFocus'
import { FORM_DISABLED_TEXT_CLASS } from '../../../lib/formStyles'
import { centsToCurrency, getCurrencySymbol } from '../../../lib/utils'
import useCurrency from '../../../hooks/useCurrency'
import { CurrencyCode } from '../../../types/currency'

type ICurrencyInput = {
	errors?: any
	name?: string
	defaultValue?: number
	placeholder?: string
	disabled?: boolean
	onChange?: (value: string) => void
	currencyCode?: CurrencyCode,
}

const CurrencyInput: FunctionComponent<ICurrencyInput> = ({
	errors,
	name,
	defaultValue,
	placeholder,
	disabled,
	onChange,
	currencyCode,
}) => {
	const companyCurrency = useCurrency();
	currencyCode = currencyCode || companyCurrency;

	return (
		<>
			<div className='relative'>
				<div className='pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3'>
					<span className={`${disabled ? 'text-charcoal-800' : 'text-charcoal-500'} sm:text-sm`}>
						{ getCurrencySymbol(currencyCode) }
					</span>
				</div>
				<div>
					<NumericFormat
						id={name}
						required
						aria-required
						disabled={disabled}
						className={`pl-7 pr-12 block w-full rounded ${INPUT_FOCUS_RING} ${errors && errors.turnover
							? 'border-error-500 bg-error-050 text-error-800 focus:border-error-500 focus:ring-error-500'
							: 'text-charcoal-800'
							} ${disabled
								? `border-charcoal-500 bg-charcoal-050/75 ${FORM_DISABLED_TEXT_CLASS} focus:border-charcoal-500 focus:ring-0`
								: ''
							}`}
						thousandSeparator=','
						placeholder={placeholder}
						defaultValue={centsToCurrency(defaultValue)}
						// react-number-format only strips a leading zero on blur, not per keystroke - select
						// the existing value on focus so the first typed digit replaces it instead of
						// appending after it (e.g. typing "1000" would otherwise show "01,000" until blur).
						onFocus={(e) => e.target.select()}
						onChange={(newValue) => onChange && onChange(newValue.target.value)}
					/>
				</div>
			</div>
			<div>
				{errors && errors.turnover && (
					<p className='mt-2 text-sm text-error-700'>
						{errors.turnover.type === 'required' && 'This field is required'}
					</p>
				)}
			</div>
		</>
	)
}

export default CurrencyInput
